import { NgModule } from "@angular/core";
import { LoadingDotsModalComponent } from "./loading-dots-modal/loading-dots-modal.component";
import { LoadingDotsComponent } from "./loading-dots/loading-dots.component";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [CommonModule],
    declarations:[LoadingDotsModalComponent,LoadingDotsComponent],
    exports:[CommonModule,LoadingDotsModalComponent,LoadingDotsComponent]
})

export class LoadingComponentsModule {}